import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SuccessErrorDialogComponent } from './components/success-error-dialog/success-error-dialog.component';
import { GtagService } from './service/gtag.service';
import { UtilsLoaderService } from './service/utils-loader.service';
import { environment } from '../environments/environment';
import { Palettes } from '../themes/palette';
import { ConfigService } from './service/config.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SuccessErrorDialogComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {

  title!: string;

  constructor(
    private gtaService: GtagService,
    private utilsLoader: UtilsLoaderService,
    private configService: ConfigService
  ) { }

  updateThemeColors(selectedPalette: any): void {
    const root = document.documentElement;
    root.style.setProperty('--primary-color', selectedPalette?.semantic?.primary?.[900]);
    root.style.setProperty('--secondary-color', selectedPalette?.semantic?.secondary?.[900]);
  }

  ngOnInit(): void {
    this.gtaService.loadGTagScript();
    this.utilsLoader.loadUtils();
    const sociedadActiva = this.configService.getSociedadActiva();
    const selectedPalette: any = Palettes[sociedadActiva] || Palettes[environment.sociedad];
    this.updateThemeColors(selectedPalette);
  }

}
